import { FC } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any */
export function componentLoader<T = any>(lazyComponent: any, attemptsLeft: number): Promise<{ default: FC<T> }> {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then((value: any) => {
        resolve(value);
      })
      .catch((error: unknown) => {
        // let us retry after 2000 ms
        setTimeout(() => {
          // console.log("Trying to download");
          if (attemptsLeft === 1) {
            // console.log("Last attempt failed");
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
        }, 2000);
      });
  });
}
